import React, { createContext, useContext, useState, useEffect } from 'react';
import NotificationsApi from 'api/notifications';

export const NotificationsContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications must be used within NotificationsProvider');
  }
  return context;
};

export const NotificationsProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchUnreadCount = async () => {
    try {
      const result = await NotificationsApi.getUnreadCount();
      setUnreadCount(result?.count || 0);
    } catch (error) {
      console.error('Failed to fetch unread count', error);
      setUnreadCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Single fetch on mount to populate the initial unread count.
    // After this, updates happen explicitly via refreshUnreadCount()
    // (e.g. when opening the bell menu or notifications page).
    fetchUnreadCount();
  }, []);

  const refreshUnreadCount = () => {
    fetchUnreadCount();
  };

  return (
    <NotificationsContext.Provider
      value={{
        unreadCount,
        loading,
        refreshUnreadCount,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};
